<template>
  <router-view/>
</template>

<script>
export default {
  mounted() {
    document.body.className = 'app'
  }
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a, .logout {
  font-weight: bold;
  color: #2c3e50;
}
.logout {
  text-decoration: underline;
  cursor: pointer;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
